import React from 'react';
import { Icon } from '../../Icon/Icon';
import './Hourpicker.css';

interface Props {
  date: Date | undefined;
  label?: string;
  onChange?: (date: Date) => void;
}

export function Hourpicker({ date, label, onChange }: Props): JSX.Element | null {
  if (!date) {
    return null;
  }

  function parseNumber(val: number): string | number {
    const absValue = Math.abs(val);
    return absValue < 10 ? `0${absValue}` : absValue;
  }

  function handleOnChange(value: string, property: 'hours' | 'minutes'): void {
    const newDate = date ? new Date(date.getTime()) : new Date();

    if (property === 'hours') {
      const hour = Number(value);
      if (hour >= 0 && hour < 24) {
        newDate.setHours(hour);
      }
    }
    if (property === 'minutes') {
      const minutes = Number(value);
      if (minutes >= 0 && minutes < 60) {
        newDate.setMinutes(minutes);
      }
    }

    if (onChange) {
      onChange(newDate);
    }
  }

  return (
    <div className="hourpicker">
      {label && (
        <header className="hourpicker__label">
          <small>
            <b>{label}</b>
          </small>
        </header>
      )}
      <div className="hourpicker__input">
        <input
          className="hourpicker__hour"
          value={parseNumber(date.getHours())}
          onChange={(event) => handleOnChange(event.target.value, 'hours')}
          min="0"
          max="23"
          size={2}
        />
        <Icon name="two-dots" />
        <input
          className="hourpicker__minutes"
          value={parseNumber(date.getMinutes())}
          onChange={(event) => handleOnChange(event.target.value, 'minutes')}
          min="0"
          max="59"
          size={2}
        />
      </div>
    </div>
  );
}
